"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LinkButton = _interopRequireDefault(require("./LinkButton.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _excluded = ["children", "href", "variant", "medium", "ariaLabel", "icon"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var LinkButton = function LinkButton(_ref) {
  var children = _ref.children,
    href = _ref.href,
    variant = _ref.variant,
    medium = _ref.medium,
    ariaLabel = _ref.ariaLabel,
    icon = _ref.icon,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_LinkButton["default"], _extends({
    "aria-label": ariaLabel,
    href: href,
    variant: variant,
    medium: medium
  }, otherProps), icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "button-icon",
    size: otherProps.iconSize || 24,
    icon: icon
  }), children);
};
LinkButton.defaultProps = {
  href: undefined,
  medium: false,
  variant: 'link',
  ariaLabel: '',
  icon: undefined,
  iconSize: undefined
};
LinkButton.propTypes = {
  ariaLabel: _propTypes["default"].string,
  /** Text or html to be displayed inside the button */
  children: _propTypes["default"].node.isRequired,
  /** A link to navigate to */
  href: _propTypes["default"].string,
  /** Flag for medium link button */
  medium: _propTypes["default"].bool,
  /** Link button variant */
  variant: _propTypes["default"].oneOf(['primary', 'naked', 'link', 'text']),
  icon: _propTypes["default"].string,
  iconSize: _propTypes["default"].number
};
LinkButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LinkButton",
  "props": {
    "href": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "A link to navigate to",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "medium": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag for medium link button",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "variant": {
      "defaultValue": {
        "value": "'link'",
        "computed": false
      },
      "description": "Link button variant",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'naked'",
          "computed": false
        }, {
          "value": "'link'",
          "computed": false
        }, {
          "value": "'text'",
          "computed": false
        }]
      },
      "required": false
    },
    "ariaLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "icon": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconSize": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "children": {
      "description": "Text or html to be displayed inside the button",
      "type": {
        "name": "node"
      },
      "required": true
    }
  }
};
var _default = LinkButton;
exports["default"] = _default;